// helix-exception: toast rail for the padded Modal fork; Helix Modal has no toast slot (F-06)
import { createContext, useContext } from 'react'

/** A rail just above a padded modal's footer, where content inside the modal can portal a toast. */
export const ModalToastSlotContext = createContext<HTMLElement | null>(null)

/** The enclosing modal's toast rail, or `null` outside a padded modal (and until the rail mounts). */
export function useModalToastSlot(): HTMLElement | null {
  return useContext(ModalToastSlotContext)
}
